import { ui } from "@/components/ui";
import { zodResolver } from "@hookform/resolvers/zod";
import { type SubmitHandler, useForm } from "react-hook-form";
import { z } from "zod";

import { useObservationMutation } from "../api/updateObservation";

const ObservationNameSchemaZ = z.object({
	observation_id: z.string().uuid("Observation ID not a valid UUID"),
	diary_id: z.string().uuid("Diary ID not a valid UUID"),
	observation_name: z.string().min(1, "Observation name is required"),
});

type ObservationNameSchemaT = z.infer<typeof ObservationNameSchemaZ>;

interface Props {
	diaryId: string;
	observationId: string;
	observationName: string;
}

const ObservationNameForm = ({
	diaryId,
	observationId,
	observationName,
}: Props) => {
	const updateObservation = useObservationMutation({
		diaryId,
	});

	const form = useForm<ObservationNameSchemaT>({
		resolver: zodResolver(ObservationNameSchemaZ),
		defaultValues: {
			diary_id: diaryId,
			observation_id: observationId,
			observation_name: observationName ?? "",
		},
	});

	const onSubmit: SubmitHandler<ObservationNameSchemaT> = async (formData) => {
		updateObservation.mutate(formData);
	};

	return (
		<ui.Form {...form}>
			<form onSubmit={form.handleSubmit(onSubmit)} className="form">
				<ui.FormField
					control={form.control}
					name="diary_id"
					render={() => (
						<ui.FormItem className="space-y-3">
							<ui.FormMessage />
						</ui.FormItem>
					)}
				/>
				<ui.FormField
					control={form.control}
					name="observation_id"
					render={() => (
						<ui.FormItem className="space-y-3">
							<ui.FormMessage />
						</ui.FormItem>
					)}
				/>
				<ui.FormField
					control={form.control}
					name="observation_name"
					render={({ field }) => (
						<ui.FormItem>
							<ui.FormLabel>Observation Name</ui.FormLabel>
							<ui.FormControl>
								<ui.Input {...field} placeholder="What is being observed?" />
							</ui.FormControl>
							<ui.FormDescription>What is being observed?</ui.FormDescription>
							<ui.FormMessage />
						</ui.FormItem>
					)}
				/>
				<ui.DialogClose asChild>
					<ui.Button type="submit">Save Name</ui.Button>
				</ui.DialogClose>
			</form>
		</ui.Form>
	);
};

export default ObservationNameForm;
